import { Chip } from '@mui/material'
import React from 'react'

export const SharedNamespaceChip: React.FC<{
  namespace: string
  onDelete(): void
}> = ({ namespace, onDelete }) => {
  return (
    <Chip
      data-testid={`chip-shared-namespace-${namespace}`}
      label={namespace}
      sx={{ margin: 0.5, width: 'fit-content' }}
      onDelete={onDelete}
    />
  )
}
